import { Component, OnInit } from '@angular/core';
import { TIPO_EMPRESAS } from 'src/app/model/empresa';
import { BackendApiService } from 'src/app/services/backend-api.service';

@Component({
  selector: 'app-page-empreendedorismo-inovacao',
  templateUrl: './page-empreendedorismo-inovacao.component.html',
  styleUrls: ['./page-empreendedorismo-inovacao.component.scss'],
})
export class PageEmpreendedorismoInovacaoComponent implements OnInit {
  tipoEmpresaParceira = TIPO_EMPRESAS.PARCEIRA;
  tipoEmpresaIncubadas = TIPO_EMPRESAS.INCUBADA;
  tipoEmpresaGraduadas = TIPO_EMPRESAS.GRADUADA;

  constructor(private backendApiService: BackendApiService) {}

  ngOnInit(): void {}
}
